<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
        <button class="button is-pulled-right is-small is-turquoise"
          @click="gotoV1">
          <span class="icon">
            <i class="mdi mdi-arrow-right" />
          </span>
          <span>V1</span>
        </button>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input class="input uppercase"
                type="text"
                placeholder="Invoice No."
                v-model="innerValue.invoiceNo"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input is-capitalized"
                type="text"
                placeholder="Creditor Name"
                v-model="innerValue.venName"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="is-checkradio"
                id="1"
                type="radio"
                name="filterType"
                :value="1"
                v-model="innerValue.filterType">
              <label for="1">Invoices with Non Zero Balance Only</label>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="is-checkradio"
                id="2"
                type="radio"
                name="filterType"
                :value="2"
                v-model="innerValue.filterType">
              <label for="2">All Invoices within Last 6 Months</label>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="is-checkradio"
                id="0"
                type="radio"
                name="filterType"
                :value="0"
                v-model="innerValue.filterType">
              <label for="0">All Invoices</label>
            </div>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button class="button"
            @click="onResetClick">
            <span class="icon">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'PaymentEntryListSideMenu',
  components: {
    AppSideMenu
  },
  props: {
    value: null
  },
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      selectedActive: 1
    }
  },
  watch: {
    innerValue: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    value: {
      handler: function(newVal, oldVal) {
        this.innerValue = this.value
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.$emit('reset')
    },
    gotoV1() {
      window.open(`${process.env.VUE_APP_ROOT_URI}/modules/paymententryview/paymententry.aspx`, '_blank')
    }
  }
}
</script>
